import { BooleanField as RaBooleanField } from "react-admin";

export const BooleanField = ({ ...prop }) => <RaBooleanField {...prop} />;

BooleanField.defaultProps = {
  sx: { display: "block", textAlign: "center" }, //value
  FalseIcon: "br",
  textAlign: "center", //label
};
